module.exports = __webpack_public_path__ + "img/AlexBabich.313651c5.png";